<div class="partner-capital-preview">
  <!--Partner capital vertical  preview-->
  <ng-container *ngIf="isEnabledVertical">
    <div class="pc-preview-vertical" *ngFor="let data of verticalData">
      <div class="pc-ver-head-content flex-box-vc-hr">
        <div class="col-date-year flex-box-vc-hr">
          <p class="no-marg" title="{{data.years.currentyear | date: 'MMMM d'}}">{{data.years.currentyear | date: 'MMMM d'}} </p>
          <p class="no-marg" title="{{data.years.currentyear | date: 'y'}}">{{data.years.currentyear | date: 'y'}}</p>
        </div>
        <div class="col-date-year latest-yr flex-box-vc-hr">
          <p class="no-marg" title="{{data.years.prevyear | date: 'MMMM d'}}"> {{data.years.prevyear | date: 'MMMM d'}} </p>
          <p class="no-marg" title="{{data.years.prevyear | date: 'y'}}">{{data.years.prevyear | date: 'y'}}</p>
        </div>
      </div>
      <ng-container *ngFor="let panel of data.partners; last as isLastOne;">
        <div class="pc-preview-body">
          <div class="exp-head">
            <span class="exp-head-title" title="{{panel.partnername}}">{{panel.partnername}}</span>
            <span class="exp-head-per" title="{{panel.allocationtypevalue}}">{{panel.allocationtypevalue}}</span>
          </div>
          <div class="pc-list">
            <ul class="cust-items">
              <li *ngFor="let child of panel.childs; first as isFirst; last as isLast;">
                <div class="custom-details">
                  <div class="exp-open flex-box-vc-hl" [ngClass]="{'open-close' : isFirst || isLast}" title="{{child.lineitemname}}"><p class="ellipse no-marg">{{child.lineitemname}}</p></div>
                  <div class="exp-currentyr flex-box-vc-hr" [ngClass]="{'open-close' : isFirst || isLast}" title="{{child.curyearamount}}"><p class="ellipse no-marg">{{child.curyearamount}}</p></div>
                  <div class="exp-previousyr flex-box-vc-hr" [ngClass]="{'open-close' : isFirst || isLast}" title="{{child.preyearamount}}"><p class="ellipse no-marg">{{child.preyearamount}}</p></div>

                </div>
              </li>
            </ul>
            <div class="custom-details pc-border" *ngIf="isLastOne">
              <div class="exp-open open-close flex-box-vc-hl" title="closing balance at the end"><p class="ellipse no-marg">closing balance at the end</p></div>
              <div class="exp-currentyr open-close flex-box-vc-hr" title="{{data.closingamount.curamount}}"><p class="ellipse no-marg">{{data.closingamount.curamount}}</p></div>
              <div class="exp-previousyr open-close flex-box-vc-hr" title="{{data.closingamount.prevamount}}"><p class="ellipse no-marg">{{data.closingamount.prevamount}}</p></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <!--Partner capital horizontal preview-->
  <ng-container *ngIf="isEnabledHorizantal">
    <div class="pc-preview-horizontal" *ngFor="let partnerCapitalData of partCapitalHorizontalDetails">
      <div class="pc-preview-partner-capital-horizontal-tbl-header" title=" {{partnerCapitalData.fullyear | date: 'y'}}">
        {{partnerCapitalData.fullyear | date: 'y'}}
      </div>
      <div class="pc-preview-partner-capital-horizontal-tbl-details">
        <table class="partner-capital-table">
          <thead>
            <tr class="partner-capital-table-header">
              <th class="th-desc"><div class="th-col-desc" title="Description">Description</div></th>
              <th *ngFor="let header of partnerCapitalData.partnerlist">
                <div class="th-col-partner" title="{{header.partnername}}">
                  {{header.partnername}}
                </div>
                <div class="th-col-partner" title="{{header.allocationtypevalue}}">{{header.allocationtypevalue}}</div>
              </th>
              <th class="th-year">
                <div class="th-col-year" title="{{partnerCapitalData.fullyear | date: 'MMMM d'}}">{{partnerCapitalData.fullyear | date: 'MMMM d'}}</div>
                <div class="th-col-year" title="{{partnerCapitalData.fullyear | date: 'y'}}">{{partnerCapitalData.fullyear | date: 'y'}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="partnerCapitalData.body">
              <tr class="partner-capital-table-details" *ngFor="let bodyData of partnerCapitalData.body;let des=index">
                <td class="td-desc">
                  <div class="td-col-desc flex-box-vc-hl" title=" {{bodyData.linenamechange}}">
                    <p class="ellipse no-marg">
                      {{bodyData.linenamechange}}
                    </p>
                  </div>
                </td>
                <td *ngFor="let partnerData of bodyData.partners_list.partners_list">
                  <div class="td-col-partner flex-box-vc-hr" title="{{partnerData.amount}}">
                    <p class="ellipse no-marg">
                      {{partnerData.amount}}
                    </p>
                  </div>
                </td>
                <td class="td-year">
                  <div class="td-col-year flex-box-vc-hr" title="{{bodyData.yearamount}}">
                    <p class="ellipse no-marg">
                      {{bodyData.yearamount}}
                    </p>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
